import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gCard from "@/components/g-card/g-card.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import axios from 'axios';
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import { defineComponent } from "vue";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";

const name = 'InfoBasicasRepeticao'

export class PhotoService {
  async getImage(ProdutoSelecionado, images){
    images = await axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoArquivo/${ProdutoSelecionado}`,
    }) .then(
      (response) => images = response.data.data )
    .catch(() => {
    });
    return images
  }
}

export default defineComponent({
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button' : gButton,
    'g-steps' : gSteps,
    'g-date-input' : gDateInput,
   },

  props: { },

  setup(){
      return {
        v$: useVuelidate()
      }
    },

  mounted () {
    // this.popularDropDownProduto()
    this.populaInfosBasicas()
    this.getEmpresaByOrcamentoId()

    this.chamarImagem()
    this.ImagemEmpresa()

  },

  updated () { },

  data () {
    return {
      popupCancelaOrc: false,
      ProdutoSelecionado:null,
      encontrouImagem: false,
      caminhoImagem: '',
      imagemEmpresa: '',
      styleImg : '',
      quantidade: null,
      ProdutoArray:[],
      DesativaLote: false,
      emissaoPedido: false,
      arquivos: [],
      img: '',
      numberRow: 0,
      images:{
        arquivo:'',
        arquivobase64: '',
        files: '',
        id: '',
        produto:'',
        },
      opcoesAmostraReferencia: [],
      categories: [{name: 'Acompanha amostra', key: 'A'}, {name: 'Marketing', key: 'M'}, {name: 'Production', key: 'P'}, {name: 'Research', key: 'R'}],
      selectedCategories: [],
      outrosmateriaisop: false,

      nomeProduto: null,
      dataCarregamento:null,
      amostra:false,
      amostraEspecificacaoTecnica:false,
      outros:false,
      descricaoOutrosMateriais:'',

      infoEntregaProduto:[],
      desativarCampoIncial:false,

      ehAdicao:true,

      quaisMateriais:'',
      displayModalConfirmacao:false,
      reorcamento: false,
      copiaOrcamentoQuantidade: false,
      timer: null,
      ClienteId: null
    }
  },

  validations() {
    let quaisMateriaisValidation

      if( this.opcoesAmostraReferencia.includes('0') || this.opcoesAmostraReferencia.includes('2')){
        quaisMateriaisValidation={
          required: helpers.withMessage('O campo quais materiais é obrigatório',required)
        }
      } else {
        quaisMateriaisValidation={}
      }
      return {

        ProdutoSelecionado:{
          required: helpers.withMessage('A seleção do produto é obrigatório', required),
        },

        quantidade: {
          required: helpers.withMessage('O campo de Quantidade necessita de um valor', required)
        },

        quaisMateriais:quaisMateriaisValidation,
      }
  },

  galerriaService: null,
    created() {
        this.galerriaService = new PhotoService();
    },

  methods: {
    verificarDatasRetroativas(infoEntregaProduto) {
      const dataAtual = new Date(); // Data atual
      dataAtual.setHours(0, 0, 0, 0);

      const verificaSeTemRetroativa = infoEntregaProduto.some(item => {
      const { dataCarregamento } = item;
  
          if (!dataCarregamento) {
            return false;
        }
          // Divide a string em partes (dia, mês, ano) e cria um novo objeto Date
          const [dia, mes, ano] = dataCarregamento.split('/');
          const dataCarregada = new Date(ano, mes - 1, dia); // Mês é zero-indexado
          dataCarregada.setHours(0, 0, 0, 0);

          return dataCarregada < dataAtual;
      });
      return verificaSeTemRetroativa;
    },

    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    erro(e){
      if(e == undefined){
        this.caminhoImagem = 'http://' + window.location.host + '/repositorio/Ilustracao_Nenhuma_Img.svg'
        this.styleImg = 'width: 100px'
      }
    },
    populaInfosBasicas(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `resgata/informacoes/basicas/${this.$route.params.id}`,
      })
        .then((Response) => {
          let infosBasicas = Response.data.data

          if(infosBasicas != null){
            this.ProdutoSelecionado = infosBasicas.produtoId;
            this.nomeProduto = infosBasicas.nomeProduto
            this.quantidade = infosBasicas.dataQuantidadeArray[0].quantidade
            this.dataCarregamento = infosBasicas.dataQuantidadeArray[0].dataCarregamentoFormatada
            this.reorcamento = infosBasicas.reorcamento
            this.copiaOrcamentoQuantidade= infosBasicas.copiaOrcamentoQuantidade
            this.ProdutoArray = infosBasicas.produtoSelecionadoLista
            this.chamarImagem()
            if(infosBasicas.dataQuantidadeArray.length > 1) {
              for (let i = 1; i < infosBasicas.dataQuantidadeArray.length; i++) {
                var element = {
                  quantidade: infosBasicas.dataQuantidadeArray[i].quantidade,
                  dataCarregamento: infosBasicas.dataQuantidadeArray[i].dataCarregamentoFormatada
                };
                this.infoEntregaProduto.push(element)
              }
            }
          }
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },
    chamarImagem(){
      if(this.ProdutoSelecionado){
        const { labelProduto } = this.ProdutoArray.filter(x => x.produtoId == this.ProdutoSelecionado)[0];
        const codigoProduto = labelProduto.split('-')[0];
        const nomeEmpresa = () => {
          let nome = labelProduto.split('|')[1];
          if(nome.includes('SUPREMA')) return 'SUPREMA';
          if(nome.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.caminhoImagem =  `http://${urlBase}/repositorio/${nomeEmpresa()}/${codigoProduto.trim()}.jpg`;
        setTimeout(() => {
          this.styleImg = 'width: 400px'
        });
      }
      else{
        this.caminhoImagem = ''
      }
    },

    buscarProdutos(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.ProdutoArray = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true, true, pesquisa).ProdutoArray;
      }, 1000);
    },

    // popularDropDownProduto(){
    //   window.clearTimeout(this.timer);
    //   this.timer = setTimeout(() => {
    //     this.ProdutoArray = ProdutoController.getProdutoByClienteIdOrcamento(this.$route.params.id).ProdutoArray
    //   }, 1000);
    // },

    voltarstep2(){
      this.$router.push(`/produto-repeticao/${this.$route.params.id}/Lote-Frete-repeticao`)
    },
    addRow() {
      if((this.infoEntregaProduto.length == 2) || !(this.quantidade) && !(this.dataCarregamento)){
        return
      }
      this.infoEntregaProduto.push({
        quantidade: '',
        dataCarregamento: null
      });
    },
    deleteRow(index) {
      this.infoEntregaProduto.splice(index, 1);
    },

    estaOrdenadoCrescente(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        // Convertendo as quantidades para números
        const quantidadeAtual = parseFloat(arr[i].quantidade);
        const proximaQuantidade = parseFloat(arr[i + 1].quantidade);
    
        if (quantidadeAtual > proximaQuantidade) {
          return false;
        }
      }
      return true;
    },
    
    insertOrcamentoQuantidade() {
        this.$refs.botaoContinuar.isBusy()
        
         let infoEntregaProduto = JSON.parse(JSON.stringify(this.infoEntregaProduto))
         if(this.quantidade != ''){
           infoEntregaProduto.unshift({
             quantidade: this.quantidade,
             dataCarregamento: this.dataCarregamento
           })
         }

         if(this.verificarDatasRetroativas(infoEntregaProduto) === true && !this.reorcamento){
          this.$toast.add({ severity: 'error', summary: 'Erro, as datas não podem ser retroativas', life: 3200 });
          this.escritobotao = true
          return
        }

         const nomeProdutoComEmpresa = this.ProdutoArray.filter(x => x.produtoId == this.ProdutoSelecionado)[0].labelProduto
         const nomeProdutoSemEmpresa = nomeProdutoComEmpresa.split('|')[0]
         const nomeProdutoSomente = nomeProdutoSemEmpresa.split('-')[1].trim()
         const codigoProduto = nomeProdutoSemEmpresa.split('-')[0].trim()
             let orcamentoquantidadeRepeticaoArray = {
           ProdutoId: this.ProdutoSelecionado,
           OrcamentoId: this.$route.params.id,
           DataQuantidadeArray: infoEntregaProduto,
           Amostra: this.amostra,
           AmostraEspecificacaoTecnica: this.amostraEspecificacaoTecnica,
           Outros: this.outros,
           DescricaoOutrosMateriais: this.descricaoOutrosMateriais,
           NomeProduto: nomeProdutoSomente,
           CodigoProduto: codigoProduto
         }
             infoEntregaProduto.forEach((e) => {
           e.quantidade = `${e.quantidade}`
         })
      let EstaOrdenado= this.estaOrdenadoCrescente(orcamentoquantidadeRepeticaoArray.DataQuantidadeArray)

      if(EstaOrdenado == false)
      {
        this.$toast.add({severity:'error', summary: 'As quantidades devem estar ordenadas.', detail:"As quantidades devem estar ordenadas da menor para a maior.", life: 5000})
        this.escritobotao = true
        this.$refs.botaoContinuar.isBusy()
        this.$isLoading(false) 

        return
      } 
      let quantidadesIguais= this.TemQuantidadesIguais(orcamentoquantidadeRepeticaoArray.DataQuantidadeArray)

      if(quantidadesIguais == true)
        {
          this.$toast.add({severity:'error', summary: 'Erro', detail:"Não são permitidas quantidades iguais.", life: 5000})
          this.escritobotao = true
          this.$refs.botaoContinuar.isBusy()
          this.$isLoading(false) 
          return
        } 
      else{
      this.axios({
        method: "post",
        url: process.env.VUE_APP_WEB_API + 'OrcamentoProdutoRepeticao/post',
        data: orcamentoquantidadeRepeticaoArray
      })
        .then((response) => {
          this.orcamentoquantidadeId = response.data;
          this.getComponentesByProdutoIdSelecionado()

        })
        .catch(() => {
        }).finally(this.$refs.botaoContinuar.isBusy)
        ;
      }

    },

    TemQuantidadesIguais(arr) {
      /*eslint-disable*/
      let occurrences = {};

      return arr.some(function(item) {
        if (occurrences[item.quantidade]) {
          return true; // Quantidade repetida encontrada
        } else {
          occurrences[item.quantidade] = true;
          return false;
        }
      });
    },

    getComponentesByProdutoIdSelecionado() {
      setTimeout(() => {
        this.axios({
          method: "get",
          url:
            process.env.VUE_APP_WEB_API +
            `Componente/GetComponentesByProdutoIdOrcamentoId/${this.$route.params.id}`,
        })
        .then((Response)=>{
          this.informacao = Response.data.data
          // Response.data.data.forEach((obj)=>{
          //   this.informacao.push(obj)
          // })
            // this.postOrcamentoComponente()
            this.$isLoading(false)
            this.$router.push(`/produto-repeticao/${this.$route.params.id}/componentes-produto-repeticao`)
          })
          .catch(() => {});
      }, 200);
    },

    postOrcamentoComponente(){
      this.axios({
        method: 'post',
          url: process.env.VUE_APP_WEB_API + 'OrcamentoComponente/post',
          data:{
            Id : this.$route.params.id, // orcamentoViewModel
            EmpresaId : this.UnidadeSelecionada, // orcamentoViewModel
            DescricaoSistema: this.SistemaSelecionado ?  this.SistemaSelecionado : 2, // orcamentoViewModel
            ComponenteData:this.informacao, // orcamentoViewModel > componenteViewModel
          }
        })
          .then(() => {
            this.$router.push(`/produto-repeticao/${this.$route.params.id}/componentes-produto-repeticao`)
          }).finally(() => this.$isLoading(false))
    },

    getEmpresaByOrcamentoId(){
      EmpresaController.getEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.UnidadeSelecionada=response.data.data.id
      })

    },

    camponumero ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) {
         $event.preventDefault();
      }
   },
    step4 () {
      if(this.v$.$invalid === true){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })

      }else
      {
       if(this.naoEstaContidoNoArray(this.infoEntregaProduto) || this.infoEntregaProduto === 0){
          this.$isLoading(true)
          this.insertOrcamentoQuantidade()
        }
      }
    },
    naoEstaContidoNoArray(array){
      let result=true
      array.forEach(obj=>{
        if(obj.dataCarregamento === this.dataCarregamento && obj.quantidade === this.quantidade){
          result=false
        }
      })
      return result
    },
  },
  computed: {
    // caminhoImagem() {
    //   if(this.ProdutoSelecionado){
    //     const { labelProduto } = this.ProdutoArray.filter(x => x.produtoId == this.ProdutoSelecionado)[0];
    //     const codigoProduto = labelProduto.split('-')[0];
    //     const nomeEmpresa = () => {
    //       let nome = labelProduto.split('|')[1];
    //       if(nome.includes('SUPREMA')) return 'SUPREMA';
    //       if(nome.includes('NORDESTE')) return 'NORDESTE';
    //       return 'JAUENSE'
    //     }

    //     const urlBase = 'http://172.16.1.8/'
    //     return `${urlBase}/repositorio/${nomeEmpresa()}/${codigoProduto.trim()}.jpg`;
    //   }
    //   return ''
    // },

    caminhoImagemExiste(){
      let caminhoImagem = this.caminhoImagem;
      return false;
    }
  },
});